const VARIANTS = new Set([
  'primary',
  'secondary',
  'quiet',
  'link',
  'destructive',
]);

export default function ApplicationButton({
  variant = 'primary',
  size = 'default',
  type = 'button',
  className = '',
  children,
  ...rest
}) {
  if (!VARIANTS.has(variant)) {
    throw new Error(`Unsupported ApplicationButton variant: ${variant}`);
  }

  if (!['default', 'compact'].includes(size)) {
    throw new Error(`Unsupported ApplicationButton size: ${size}`);
  }

  const classes = [
    'av-app-button',
    `av-app-button--${variant}`,
    size === 'compact' ? 'av-app-button--compact' : '',
    className,
  ].filter(Boolean).join(' ');

  return (
    <button className={classes} type={type} {...rest}>
      {children}
    </button>
  );
}
